import React from 'react'
import AnimationRevealPage from "../../../helpers/AnimationRevealPage";
import HeroSection from './NewHeroSection'
import MainSection1 from './MainSection1'
import Feature1 from './Feature1'
import Feature2 from './Feature2'
import Feature3 from './Feature3'
import Feature4 from './Feature4'
import FinalQuote from './FinalQuote'
import IndustriesWeServe from './IndustriesWeServe'
import WhyChoose from './WhyChooseAeroInfravue'
import FinalSection from './FinalSection'

export default function index() {
  return (
    <div>
        <HeroSection/>
        <MainSection1/>
        <AnimationRevealPage>
       
        <Feature2/>
        <Feature1/>
       
        <Feature4/>
        <Feature3/>
        </AnimationRevealPage>
        <IndustriesWeServe />
        <FinalQuote/>
        <WhyChoose />
        <FinalSection />
    </div>
  )
}
